/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_Cross_Reference_HintInputs */

const en_reading_class_cross_reference_hint = /** @type {(inputs: Reading_Class_Cross_Reference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Like “see Figure 2”`)
};

const es_reading_class_cross_reference_hint = /** @type {(inputs: Reading_Class_Cross_Reference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como «ver Figura 2»`)
};

/**
* | output |
* | --- |
* | "Like “see Figure 2”" |
*
* @param {Reading_Class_Cross_Reference_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_cross_reference_hint = /** @type {((inputs?: Reading_Class_Cross_Reference_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_Cross_Reference_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_cross_reference_hint(inputs)
	return en_reading_class_cross_reference_hint(inputs)
});